module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shelf/activity/activity.component.css
// module id = ./src/app/shelf/activity/activity.component.css
// module chunks = main